const th = {
  tours: {
    pkg1: {
      price: "€790",
      title: "ยุโรป/โมร็อกโก หลบหนีวันหยุดสุดสัปดาห์ที่หรูหรา",
      duration: "3 คืน / 4 วัน ",
      hl1: "รวมเที่ยวบินตรงไปกลับ (ลอนดอน/ยุโรป)",
      hl2: "โรงแรมหรูระดับ 4-5 ดาว",
      hl3: "ฮัมมัมโมร็อกโกแบบดั้งเดิม",
      hl4: "เวิร์คช็อปการทำอาหารและศิลปะ",
      hl5: "การแสดงสดแบบโมร็อกโก",
      hl1_brief: "รวมเที่ยวบินตรงไปกลับ",
      subtitle: "แพ็คเกจรวมทุกอย่าง – จาก A ถึง Z",
      flight1: "เที่ยวบินตรงไปกลับ",
      flight2: "น้ำหนักสัมภาระที่โหลดใต้ท้องเครื่อง 20 กก",
      flight3: "น้ำหนักสัมภาระขึ้นเครื่องสูงสุด 8 กก",
      inc1: "รับที่สนามบินและโอนกลับ",
      inc2: "โรงแรม 4-5 ดาว (อาหารสองมื้อ)",
      inc3: "อาหารโมร็อกโกที่สดใหม่และเป็นของแท้",
      inc4: "ประสบการณ์ชาและขนมอบแบบดั้งเดิม",
      inc5: "ไกด์นำเที่ยวมืออาชีพและคนขับรถส่วนตัว",
      inc6: "การขนส่งปรับอากาศที่ทันสมัย",
      inc7: "การแสดงสดพิเศษ (นักร้องและนักเต้น)",
      inc7_brief: "การแสดงสดพิเศษ",
      inc8: "ทัวร์ตลาดแบบดั้งเดิม (เครื่องเทศ โคมไฟ พรม)",
      inc8_brief: "ทัวร์ตลาดแบบดั้งเดิม",
      inc9: "เวิร์คช็อปการทำอาหารและศิลปะ (ต้องจองล่วงหน้า)",
      inc9_brief: "เวิร์คช็อปการทำอาหารและศิลปะ",
      inc10: "เยี่ยมชมน้ำพุธรรมชาติและจุดชมวิว",
      inc11: "ทริปหนึ่งวันไปยัง Chefchaouen และ Ifrane",
      inc12: "เยี่ยมชมกับครอบครัวชาวโมร็อกโกในท้องถิ่น",
      inc13: "ประสบการณ์สุดเซอร์ไพรส์ระหว่างทัวร์",
      suit1: "คู่รัก",
      suit2: "ครอบครัว",
      suit3: "กลุ่ม",
      suit4: "นักเดินทาง��นเดียว",
      suit5: "ผู้สูงอายุ",
      suit6: "บริษัท",
      suit7: "ตัวแทนการท่องเที่ยว",
      suit8: "ผู้ประกอบการทัวร์"
    },
    pkg2: {
      price: "€1490",
      title: "ทัวร์ค้นพบที่หรูหราของโมร็อกโก",
      duration: "6 คืน / 7 วัน ",
      hl1: "แพ็คเกจ A",
      hl2: "การเคลื่���นไหวของแอตลาส",
      hl3: "มาราเกช- เอสเซาอิรา - เมอร์ซูกา - วาร์ซาซเต - มาราเกช-",
      hl4: "บิ๊กเซอร์ไพรส์ ❤️",
      hl5: "แพ็คเกจบี",
      subtitle: "เส้นทางเฟสและโมร็อกโกเหนือ (รวมทุกอย่าง)",
      routeText: "2 คืน Fes, 1 คืน Chefchaouen, 1 คืน Tangier, 1 คืน Ifrane, 1 คืนสุดท้าย Fes",
      flight1: "เที่ยวบินตรงไปกลับจากยุโรป",
      flight2: "กระเป๋าเดินทาง 20 กก. + สัมภาระถือขึ้นเครื่อง",
      trans1: "รับและส่งที่สนามบิน",
      trans2: "พนักงานขับรถมืออาชีพและไกด์นำเที่ยวส่วนตัว",
      trans3: "รถปรับอากาศใหม่",
      hotel1: "โรงแรมระดับ 4-5 ดาว",
      hotel2: "สถานที่ระดับพรีเมียม",
      hotel3: "บริการระดับสูง",
      food1: "อาหารสองมื้อ",
      food2: "อาหารต้นตำรับ",
      food3: "ชาและขนมอบแบบดั้งเดิม",
      exp1: "การแสดงสดแบบโมร็อกโก",
      exp2: "ตลาดแบบดั้งเดิม (เครื่องเทศ โคมไฟ พรม)",
      exp2_brief: "ตลาดแบบดั้��เดิม",
      exp3: "ฮัมมัมโมร็อกโกแบบดั้งเดิม",
      exp4: "เยี่ยมชมธรรมชาติและป่าไม้",
      exp4_brief: "เยี่ยมชมธรรมชาติ",
      exp5: "จุดชมวิวที่สวยงามและเดย์ทริป",
      exp6: "เวิร์คช็อปการทำอาหารและศิลปะ",
      exp7: "เยี่ยมชมกับครอบครัวในท้องถิ่น",
      exp8: "เซอร์ไพรส์พิเศษระหว่างการเดินทาง",
      suit1: "คู่รัก",
      suit2: "ครอบครัว",
      suit3: "กลุ่ม",
      suit4: "นักเดินทางคนเดียว",
      suit5: "ผู้สูงอายุ",
      suit6: "บริษัท",
      suit7: "ตัวแทนการท่องเที่ยว"
    },
    pkg3: {
      price: "€1990",
      title: "ประสบการณ์อันยิ่งใหญ่ของโมร็อกโก",
      duration: "10 คืน / 11 วัน ",
      hl1: "บริการภาคพื้นดินระดับพรีเมี่ยมเต็มรูปแบบ",
      hl2: "คาซาบลังกา มาร์ราเกช และเฟส",
      hl3: "ความประหลาดใจในอากาดีร์และทะเลทรายซาฮารา",
      hl4: "เยี่ยมชมวาร์ซาเซตและเชฟชาอูน",
      hl5: "ดนตรีสดและการแสดงพิเศษ",
      subtitle: "✨ Morocco Grand Experience (บริการภาคพื้นดินเท่านั้น)",
      arrivalText: "คาซาบลังกาหรือมาร์ราเกช",
      routeText: "คาซาบลังกา, ราบัต, 2 คืน เฟส, แทนเจียร์, เชฟชาอูน, อิเฟรน, 2 คืน มาร์ราเกช, อากาดีร์, วาร์ซาเซต, คืนสุดท้าย มาร์ราเกช",
      note2: "กลุ่ม > 40: ส่วนลดพิเศษ $50 ต่อคน",
      note3: "ไม่รวมเที่ยวบินระหว่างประเทศและการประกันภัย",
      note4: "ไม่รวมทิปคนขับรถ/ไกด์",
      inc1: "บริการภาคพื้นดินระดับพรีเมี่ยมเต็มรูปแบบ",
      inc2: "โรงแรม 4-5 ดาว (อาหารสองมื้อ)",
      inc3: "ไกด์นำเที่ยวมืออาชีพและคนขับรถส่วนตัว",
      inc4: "รถบัสปรับอากาศหรือรถสองแถว",
      inc5: "การแสดงสดและบรรยากาศดนตรี",
      inc6: "ตลาดแบบดั้งเดิมและการเข้าชมฮัมมัม",
      inc7: "เวิร์คช็อปการทำอาหารและศิลปะ",
      inc8: "ทัศนศึกษาป่าไม้ น้ำพุ และจุดชมวิว",
      inc9: "เยี่ยมชมกับครอบครัวในท้องถิ่น",
      inc10: "เซอร์ไพรส์พิเศษระหว่างการเดินท��ง"
    },
    pageTitle: "ทัวร์และ��พ็คเกจ",
    pageSubtitle: "เลือกจากแพ็คเกจทัวร์โมร็อกโกที่คัดสรรมาอย่างดีของเรา",
    sectionTitle: "แพ็คเกจทัวร์ของเรา",
    sectionIntro: "ตั้งแต่การผจญภัยในทะเลทรายไปจนถึงการหลีกหนีจากชายฝั่ง เรามีแพ็คเกจที่สมบูรณ���แบบสำหรับนักเดินทางทุกคน",
    howToBook: "วิธีการจอง",
    step1Title: "เลือกทัวร์",
    step1Text: "เรียกดูแพ็คเกจของเราและเลือกแพ็คเกจที่เหมาะกับคุณที่สุด",
    step2Title: "คลิกจองเลย",
    step2Text: "คลิกปุ่ม \"จองทันที\" บนทัวร์ที่คุณเลือก",
    step3Title: "กรอกรายละเอียด",
    step3Text: "ระบุวันเดินทางแ��ะข้อมูลส่วนบุคคลของคุณ",
    step4Title: "การยืนยัน",
    step4Text: "รับการยืนยันและรายละเอียดแผนการเดินทางทางอีเมล",
    customTitle: "ต้องการแพ็คเกจแบบกำหนดเองหรือไม่?",
    customText: "ติดต่อเราเพื่อสร้างประสบการณ์ทัวร์โมร็อกโกส่วนตัว",
    customBtn: "ได้รับการติดต่อ",
    days: "วัน",
    highlights: "ไฮไลท์:",
    bookNow: "จองตอนนี้",
    highlightsLabel: "ไฮไลท์:",
    viewFullDetails: "ดูรายละเอียดทั้งหมด",
    viewDetails: "ดูรายละเอียด",
    premiumPackage: "แพ็คเกจพรีเมียม",
    arrival: "มาถึง:",
    route: "เส้นทาง:",
    flights: "เที่ยวบิน:",
    transportation: "การขนส่ง:",
    hotels: "โรงแรม:",
    foodDining: "อาหารและรับประทานอาหาร:",
    whatsIncluded: "มีอะไรบ้าง:",
    attractionsExperiences: "สถานที่ท่องเที่ยวและ��ระสบการณ์:",
    itinerary: "กำหนดการเดินทาง:",
    optionalExperiences: "ประสบการณ์เสริม:",
    availableUponRequest: "มีให้บริการตามคำขอ:",
    specialSaharaExperience: "ประสบการณ์พิเศษในทะเลทรายซาฮารา:",
    suitableFor: "เหมาะสำหรับ:",
    importantNotes: "หมายเหตุสำคัญ:",
    priceInformation: "ข้อมูลราคา:",
    priceWarningText: "ราคาอาจมีการเปลี่ยนแปลงขึ้นอยู่กับราคาเที่ยวบิน อัตราแลกเปลี่ยน วันหยุด ฤดูกาล และความพร้อมของโรงแรม",
    safetyComfort: "ความปลอดภัยและความสะดวกสบาย:",
    safetyText: "เราทำงานร่วมกับหน่วยงานของโมร็อกโกและบริการรักษาความปลอดภัยเพื่อความปลอดภัยและความสะดวกสบายของแขกของเรา",
    safetyTextBrief: "ประสานงานกับทางการโมร็อกโกเพื่อความปลอดภัยของคุณ",
    givesMore: "โมร็อกโกรักคุณให้มากขึ้น:",
    givesMoreText: "ความรัก ความเอาใจใส่ ความเป็นมืออาชีพ ความสุข และความปลอดภัยเพิ่มมากขึ้น ทัวร์ที่ง่ายและผ่อนคลายพร้อมการต้อนรับอย่างอบอุ่นของมนุษย์",
    givesMoreBrief: "โมร็อกโกรักคุณ:",
    givesMoreTextBrief: "ความรัก ความเอาใจใส่ และความเป็นมืออาชีพมากขึ้น",
    bookThisPackage: "จองแพ็คเกจนี้",
    backToPackages: "กลับไปที่แพ็คเกจ",
    premiumMoroccoPackages: "แพ็คเกจโมร็อกโกระดับพรีเมียม",
    premiumMoroccoPackagesDesc: "ประสบการณ์พิเศษที่คัดสรรมาอย่างพิถีพิถันเพื่อแขกผู้มีเกียรติของเรา",
    suitable: {
      couples: "คู่รัก",
      families: "ครอบ���รัว",
      groups: "กลุ่ม",
      solo: "นักเดินทางคนเดียว",
      seniors: "ผู้สูงอายุ",
      companies: "บริษัท",
      agencies: "ตัวแทนการท่องเที่ยว",
      operators: "ผู้ประกอบการทัวร์"
    },
    pkg4: {
      title: "ประสบการณ์โมร็อกโกที่หรูหรา",
      duration: "16 คืน / 17 วัน",
      price: "รวมทุกอย่างแล้ว",
      hl1: "คาซาบลังกา • ราบัต • เฟซ • แทนเจียร์ • เชฟชาอูน",
      hl2: "อิเฟรน • ทะเลทรายเมอร์ซูกา ซาฮารา",
      hl3: "เอสเซาอิรา • เทือกเขาอูริกาและแอตลาส • มาราเกช",
      hl3_brief: "เยี่ยมชมเท��อกเขาแอตลาส",
      hl4: "แคมป์ทะเลทรายสุดหรู 2 คืนพร้อมทัวร์อูฐและรถจี๊ป",
      hl5: "พระอาทิตย์ขึ้นและพระอาทิตย์ตกอันมหัศจรรย์ • นอนหลับใต้แสงดาว",
      subtitle: "✨ ประสบการณ์จักรวรรดิโมร็อกโก & ซาฮารา - การเดินทางที่สมบูรณ์ (16 คืน / 17 วัน)",
      routeText: "คาซาบลังกา (1 คืน), ราบัต, เฟซ (2 คืน), แทนเจียร์ (1 คืน), เชฟชาอูน (1 คืน), อิเฟรน (1 คืน), เมอร์ซูกาซาฮารา (2 คืน), เอสเซาอิรา (2 คืน), เทือกเขาอูริกาและแอตลาส (1 คืน), มาราเกช (3 คืน)",
      inc1: "โรงแรม 4 ★ / 5 ★",
      inc2: "แคมป์ทะเลทรายสุดหรูพร้อมเครื่องปรับอากาศ",
      inc2_brief: "โรงแรมระดับ 4-5 ดาว",
      inc3: "อาหารสามมื้อ / อาหารโมร็อกโกระดับพรีเมียม",
      inc3_brief: "ไกด์นำเที่ยวมืออาชีพ",
      inc4: "คู่มือหลายภาษาระดับมืออาชีพ",
      inc4_brief: "การแสดงสดพิเศษ",
      inc5: "ก���รคมนาคมส่วนตัวที่ทันสมัย",
      inc5_brief: "ตลาดแบบดั้งเดิม",
      inc6: "รถโค้ชปรับอากาศ",
      inc7: "WiFi • ทีวี • ตู้เย็นบนเรือ",
      inc8: "คนขับส่วนตัวตลอดทัวร์",
      inc9: "ทัวร์อูฐ",
      inc10: "ประสบการณ์รถจี๊ปทะเลทราย",
      inc11: "การแสดงพื้นบ้านและดนตรีสด",
      inc12: "การแสดงเต้นรำโมร็อกโก",
      inc13: "เวิร์คช็อปการทำอาหาร",
      inc14: "ประสบการณ์ตลาดและตลาดสด",
      inc15: "พรม • เครื่องเทศ • ดอกไ��้ • งานหัตถกรรมแบบดั้งเดิม",
      inc16: "ทะเลสาบ • แม่น้ำ • เทือกเขาแอตลาส",
      inc17: "ประสบการณ์พิเศษพระอาทิตย์ขึ้นและพระอาทิตย์ตก",
      inc18: "การสนับสนุนโดยตรงทุกวันตลอด 24 ชั่วโมง",
      optional1: "ประสบการณ์บอลลูนอากาศร้อน",
      optional2: "การอัพเกรดวีไอพี",
      optional3: "ประสบการณ์อันหรูหรา",
      optional4: "บริการรักษาความปลอดภัยส่วนตัว",
      optional5: "บริการช่วยเหลือทางการแพทย์",
      optionalNote: "บริการระดับพรีเมียมบางอย่างอาจต้องมีส่วนเสริมที่ยุติธรรมเพิ่มเติม",
      sahara1: "เต็นท์ทะเลทรายปรับอา��าศระดับพรีเมียม",
      sahara2: "บรรยากาศดนตรีแคมป์ไฟ",
      sahara3_brief: "ทัศนศึกษาด้วยรถจี๊ปและการขี่อูฐ",
      itinerary1: "คาซาบลังกา - มาถึง (1 คืน)",
      itinerary2: "ราบัต - เมืองหลวง",
      itinerary3: "เฟซ - โมร็อกโกด้านจิตวิญญาณและวัฒนธรรม (2 คืน)",
      itinerary4: "แทนเจียร์ - ที่ซึ่งยุโรปพบกับแอฟริกา (1 คืน)",
      itinerary5: "Chefchaouen - เดอะบลูเพิร์ล (1 คืน)",
      itinerary6: "Ifrane - สวิตเซอร์แลนด์โมร็อกโก (1 คืน)",
      itinerary7: "ทะเลทรายเมอร์ซูกาซาฮารา (2 คืน) - แคมป์ทะเลทรายสุดหรู - ประสบการณ์ขี่อูฐ - ทัวร์รถจี๊ป - พระอาทิตย์ขึ้นและพระอาทิตย์ตกอันมหัศจรรย์ - นอนใต้แสงดาว",
      itinerary8: "เอสเซาอิรา - แอตแลนติกโอเชียนเอสเคป (2 คืน)",
      itinerary9: "เทือกเขาอูริกาและแอตลาส (1 คืน)",
      itinerary10: "มาราเกช - เมืองแดง (3 คืน)"
    }
  },
  tourMini: {
    years: "2026 - 2027",
    days: "10 วัน",
    nights: "/ 9 คืน",
    title: "พรีเมี่ยมโมร็อกโก\nทัวร์",
    departures: "ออกเดินทางทุกเดือน",
    allIncluded: "รวมอยู่ด้วย\nคณะกรรมการเต็มรูปแบบ",
    recommendations: "ข้อแนะนำ",
    recCount: "นักเดินทางที่มีความสุขมากกว่า 500 คน"
  },
  testimonials_data: {
    testi1: {
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      name: "ซาราห์ จอห์นสัน",
      title: "ลอนดอนสหราชอาณาจักร",
      text: "Morocco Loves You ทำให้ทริปในฝันของฉันเป็นจริง! ทุกรายละเอียดได้รับการจัดระเบียบอย่างสมบูรณ์แบบ ตั้งแต่โรงแรมหรูไปจนถึงประสบการณ์ที่แท้จริง บริการไม่มีที่เปรียบ ฉันกำลังวางแผนกลับมาเยี่ยมอีกครั้ง!",
      rating: 5
    },
    testi2: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "ไมเคิล เฉิน",
      title: "สิงคโปร์",
      text: "ในฐานะนักเดินทางเพื่อธุรกิจ ฉันรู้สึกประทับใจกับความเป็นมืออาชีพและการปรับแต่งได้ การดูแลแบบวีไอพีตั้งแต่วันแรก แผนการเดินทางเฉพาะบุคคล และการขนส่งท��่ไร้ที่ติ แนะนำเป็นอย่างยิ่งสำหรับการเดินทางเพื่อผู้บริหาร",
      rating: 5
    },
    testi3: {
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      name: "เอ็มม่า วิลสัน",
      title: "ซิดนีย์, ออสเตรเลีย",
      text: "ประสบการณ์ทะเ��ทรายนั้นมหัศจรรย์มาก! การนอนใต้แสงดาว การขี่อูฐ และการต้อนรับอันอบอุ่นแบบโมร็อกโกนั้นเกินความคาดหมายทั้งหมด ขอบคุณที่สร้างความทรงจำตลอดชีวิต!",
      rating: 5
    },
    testi4: {
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      name: "เจมส์ โรดริเกซ",
      title: "กรุงมาดริ���ประเทศสเปน",
      text: "การวางแผนการเดินทางกับครอบครัวอาจทำให้เครียด แต่ Morocco Loves You จัดการทุกอย่างได้อย่างยอดเยี่ยม ปลอดภัย ให้ความรู้ และสนุกสนานสำหรับทุกวัย ลูก ๆ ของเรายังคงพูดคุยเกี่ยวกับการเยี่ยมชมเมดินา!",
      rating: 5
    },
    testi5: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "แอนนา มุลเลอร์",
      title: "กรุงเบอร์ลินประเทศเยอรมนี",
      text: "ฉันชื่นชมความถูกต้องทางวัฒนธรรมและความเคารพที่แสดงต่อประเพณีท้องถิ่น นี่ไม่ใช่แค่การท่องเที่ยวเท่านั้น มันเป็นการดื่มด่ำกับ���ัฒนธรรมอย่างแท้จริง ไชโยทั้งทีม!",
      rating: 5
    },
    testi6: {
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      name: "เดวิด ทอมป์สัน",
      title: "โทรอนโต แคนาดา",
      text: "การเข้าถึงสำหรับผู้สูงอายุนั้นยอดเยี่ยมมาก การดำเนินชีวิตที่สะดวกสบาย มัคคุเทศก์ที่คอยช่วยเหลือ และที่พักสุดหรูทำให้ปู่ย่าตายายของฉันมีความสุขอย่างไม่น่าเชื่อ บริการที่ใส่ใจอย่างแท้จริง",
      rating: 5
    },
    testi7: {
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      name: "ลิซ่า แอนเดอร์สัน",
      title: "นิวยอร์กสหรัฐอเมริกา",
      text: "คนรักอาหารที่นี่! ประสบการณ์การทำอาหารนั้นยอดเยี่ยมมาก อาหารทุกมื้อมีเรื่องราว ไกด์ทุกคนแสดงความหลงใหลอย่างแท้จริง รสชาติของโมร็อกโกจะคงอยู่กับฉันตลอดไป",
      rating: 5
    },
    testi8: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "มาร์คัส สมิธ",
      title: "ลอสแองเจลิสสหรัฐอเมริกา",
      text: "เต็มไปด้วยการผจญภัยแต่หรูหรา - ตรงกับสิ่งที่ฉันกำลังมองหา การเดินป่า Atlas ซาฟารีในทะเลทราย ทั้งหมดนี้มาพร้อมความสะดวกสบายระดับวีไอพี คุ้มค่าทุกเพนนี!",
      rating: 5
    },
    testi9: {
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      name: "โซฟี โลรองต์",
      title: "ปารีส, ฝรั่งเศส",
      text: "ทริปโรแมนติกสุดพิเศษ! พระอาทิตย์ตกในทะเลทรายซาฮารา รับประทานอาหารเย็���แบบส่วนตัวพร้อมชมเมืองมาร์ราเกช และบริการที่เอาใจใส่ตลอด Morocco Loves You ดำเนินชีวิตตามชื่อของพวกเขาอย่างแท้จริง",
      rating: 5
    },
    intro: "พบกับแขกที่พึงพอใจของเราซึ่งได้สัมผัสประสบการณ์โมร็อกโกผ่านบริการของเรา"
  },
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  },
  nav: {
    home: "บ้าน",
    about: "เกี่ยวกับเรา",
    destinations: "จุดหมายปลายทาง",
    tours: "ทัวร์และแพ็คเกจ",
    gallery: "แกลเลอรี่",
    testimonials: "ข้อความรับรอง",
    blog: "บล็อก",
    contact: "ติดต่อเรา",
    experiences: "ประสบการณ์",
    vip: "ธุรกิจวีไอพี",
    vipFull: "การเดินทางเพื่อธุรกิจวีไอพี",
    worldcup: "ฟุตบอลโลก 2030",
    careers: "อาชีพ",
    chatWhatsApp: "แชทบน WhatsApp",
    jewishHeritage: "ท่องเที่ยวโคเชอร์",
    menu: "เมนู"
  },
  hero: {
    welcome: "ยินดีต้อนรับสู่โมร็อกโก",
    welcomeHome: "ยินดีต้อนรับกลับบ้าน.",
    subtitle: "ทัวร์หรูส่วนตัว ประสบการณ์จริง",
    subtitleLine2: "และบริการส่วนบุคคลเต็มรูปแบบทั่วโมร็อกโก —",
    subtitleGold: "จัดการเป็นการส่วนตัวโดย CEO",
    whatsappBtn: "แชทกับ Ilan (CEO) ตอนนี้บน WhatsApp",
    badgeFast: "การตอบสนองที่รวดเร็ว",
    badgePersonal: "บริการส่วนบุคคล",
    badge247: "พร้อมให้บริการทุกวันตลอด 24 ชั่วโมง",
    limitedAvail: "มีจำนวนจำกัด",
    personalizedOnly: "ทริปส่วนตัวเท่านั้น"
  },
  strip: {
    privateTours: "ทัวร์ส่วนตัว",
    localExperts: "ผู้เชี่ยวชาญในท้องถิ่น",
    bestHotels: "โรงแรมที่ดีที่สุด",
    luxuryTransport: "การขนส่งที่หรูหรา",
    satisfaction: "ความพึงพอใจ 100%"
  },
  cta: {
    whatsapp: "แชทกับ Ilan (CEO) ตอนนี้บน WhatsApp",
    whatsappFloating: "แชทบน WhatsApp",
    whatsappInquiry: "สวัสดี ฉันสนใจประสบการณ์ท่องเที่ยวโมร็อกโกแบบพรีเมี่ยม"
  },
  home: {
    vipBannerTitle: "ประสบการณ์การเดินทางวีไอพีโมร็อกโก",
    vipBannerText: "การเข้าถึงพิเศษ คนขับรถส่วนตัว และที่พักหรูหราที่ออกแบบมาเพื่อนักเดินทางที่ชาญฉลาด",
    vipBannerBtn: "ค้นพบบริการวีไอพี",
    wcBadge: "🇲🇲 โมร็อกโก ฟุตบอลโลก 2030",
    wcTitle: "โมร็อกโก 2030",
    wcText: "แพ็คเกจท่องเที่ยวฟุตบอลโลกสุดพิเศษที่ผสมผสานฟุตบอล วัฒนธรรมโมร��อกโก การต้อนรับระดับวีไอพี และประสบการณ์สุดหรู",
    wcBtn: "ดูแพ็คเกจ",
    galleryTitle: "แกลเลอรี่",
    gallerySubtitle: "เหลือบมองการเดินทางโมร็อกโกในอนาคตของคุณ",
    exploreDestination: "สำรวจจุดหมายปลายทาง",
    featuredToursTitle: "ทัวร์และแพ็คเกจแนะนำ",
    featuredToursSubtitle: "ประสบการณ์ที่คัดสรรมาอย่างดีเพื่อการผจญภัยแบบโมร็อกโกที่สมบูรณ์แบบ",
    viewAllTours: "ดูทัวร์ทั้งหมด",
    culinaryTitle: "อาหารของเรา - ดีที่สุดในโลก",
    culinarySubtitle: "สัมผัสประสบการณ์ความเป็นเลิศด้านอาหารโมร็อกโก 🍲",
    culinaryBtn: "ค้นพบประสบการณ์การทำอาหาร",
    culinaryIntro: "ที่ Morocco Loves You การรับประทานอาหารไม่ได้เป็นเพียงการรับประทานอาหารเท่านั้น เป็นการเดินทางสู่ใจกลางวัฒนธรรมโมร็อกโก เรานำเสนอประสบการณ์การทำอาหารที่แท้จริงและคัดสรรมาอย่างดี ตั้งแต่อาหารปรุงเองที่บ้านแบบดั้งเดิมไปจนถึงการทำอาหารโมร็อกโกระดับไฮเอนด์ ทั้งหมดนี้ปรุงด้วยความรักและวัตถุดิบสดใหม่ในท้���งถิ่น",
    culinaryVideoTitle: "วิดีโอประสบการณ์การทำอาหาร",
    culinaryFeatures: [
      "Tagines แบบดั้งเดิม",
      "คูสคูสแท้",
      "ขนมอบโมร็อกโก",
      "พิธีชงชา",
      "ชั้นเรียนทำอาหาร",
      "เครื่องเทศท้องถิ่น",
      "ส่วนผสมออร์แกนิก",
      "อาหารปรุงเองที่บ้าน"
    ],
    videoTitle: "คำแนะนำ",
    unityQuote: "Morocco Loves You ยินดีต้อนรับทุกวัฒนธรรม ทุกความเชื่อ และทุกชนชาติ",
    unityAlt: "โมร็อคโครักคุณแบนเนอร์ความสามัคคี",
    testimonialsTitle: "สิ่งที่แขกวีไอพีของเราพูด",
    testimonialsSubtitle: "รีวิวจริงจากนักเดินทางต่างชาติ",
    readMoreReviews: "อ่านรีวิวเพิ่มเติม",
    viewAllTransport: "ดูทั้งหมด การขนส่ง",
    transportTitle: "การขนส่งและคนขับรถวีไอพีของเรา",
    transportSubtitle: "ความหรูหรา ความสะดวกสบาย และปลอดภัยทั่วโมร็อกโก 🌍",
    transportIntro: "ที่ Morocco Loves You การคมนาคมไม่ได้เป็นเพียงการเคลื่อนย้ายจา��ที่หนึ่งไปอีกที่หนึ่งเท่านั้น มันเป็นส่วนหนึ่งของประสบการณ์ เราจัดหายานพาหนะปรับอากาศที่ทันสมัย ​​สะอาด สะดวกสบาย และมีเครื่องปรับอากาศทั่วโมร็อกโก พร้อมด้วยคนขับมืออาชีพ การต้อนรับที่อบอุ่น และบริการระดับวีไอพีตั้งแต่วินาทีแรก"
  },
  destinations: {
    pageTitle: "สำรวจจุดหมายปลายทางของโมร็อกโก",
    pageSubtitle: "ค้นพบสถานที่อันน่าทึ่งเพื่อเยี่ยมชมทั่วโมร็อกโกที่สวยงาม",
    sectionTitle: "จุดหมายปลายทางทั้งหมด",
    sectionIntro: "โมร็อกโกเป็นประเทศที่มีภูมิประเทศที่หลากหลายและมีมรดกทางวัฒนธรรมอันยาวนาน สำรวจจุดหมายปลายทางที่เราคัดสรรมาอย่างดี:",
    exploreNow: "สำรวจเลย",
    ctaTitle: "พร้อมวางแผนการเดินทางของคุณแล้วหรือยัง?",
    ctaText: "เรียกดูทัวร์และแพ็คเกจที่คัดสรรแล้วของเราเพื่อค้นหาประสบการณ์โมร็อกโกที่สมบูรณ์แบบ",
    ctaBtn: "ดูทัวร์และแพ็คเกจ"
  },
  experiences: {
    pageTitle: "ความเป็นเลิศด้านการทำอาหารโมร็อกโก",
    pageSubtitle: "ค้นพบอาหารของเรา - ดีที่สุดในโลก",
    bookViaWhatsApp: "จองผ่าน WhatsApp",
    introTitle: "ประสบการณ์การทำอาหารโมร็อกโกอันเป็นเอกลักษณ์ของเรา",
    introHighlight: "รสชาติต้นตำรับ วัตถุดิบสดใหม่ ประเพณีที่สืบทอดมาหลายศตวรรษ และการต้อนรับที่ไม่อาจลืมเลือน",
    introP1: "ยินดีต้อนรับสู่รสชาติที่แท้จริงของโมร็อกโก",
    introP2: "ที่ Morocco Loves You อาหารไม่ใช่แค่มื้ออาหารเท่านั้น แต่ยังเป็นวัฒนธรรม ประวัติศาสตร์ ครอบครัว การต้อนรับขับสู้ และความรัก",
    introP3: "เป็นเวลาหลายศตวรรษมาแล้วที่อาหารโมร็อกโกถือเป็นอาหารที่อุดมสมบูรณ์ ดีต่อสุขภาพ และมีรสชาติดีที่สุดในโลก",
    introP4: "ประเพณีการทำอาหารของเราผสมผสานอิทธิพลของอาหรับ เบอร์เบอร์ ยิวโมรอคโค อันดาลูเซียน เมดิเตอร์เรเนียน และแอฟริกาเข้าด้วยกัน ทำให้เกิดสูตรอาหารอันเป็นเอกลักษณ์ที่เก็บรักษาไว้มานานกว��า 500 ปี",
    prepTitle: "ศิลปะการเตรียมการแบบโมร็อกโก",
    prepP1: "ทุกอย่างจัดเตรียมด้วยความใส่ใจ ความหลงใหล วัตถุดิบสดใหม่ในท้องถิ่น และเครื่องเทศโมร็อกโกแท้ๆ",
    prepP2: "เราคัดสรรร้านอาหารที่เชื่อถือได้ ประสบการณ์ในท้องถิ่นที่แท้จริง และจุดหมายปลายทางด้านอาหารที่มีคุณภาพสำหรับแขกของเราอย่างรอบคอบ",
    prepP3: "โมร็อกโกเป็นที่รู้จักทั่วโลกในด้านตลาดที่เต็มไปด้วยสีสัน เกษตรกรรมสด ผลิตภัณฑ์จากธรรมชาติ เครื่องเทศ มะกอก ส้ม ขนมอบ ชามิ้นต์ และการต้อนรับที่ไม่อาจลืมเลือน",
    journeyVideos: "วิดีโอการเดินทางการทำอาหาร",
    highlightsTitle: "ไฮไลท์การทำอาหารแบบดั้งเดิม",
    highlightTagine: "Tagine โมร็อกโกแท้ๆ",
    highlightCouscous: "Couscous แบบดั้งเดิม",
    highlightVegetables: "ผักสดและส่วนผสมจากธรรมชาติ",
    highlightPastries: "ขนมอบและขนมหวานโฮมเมด",
    highlightBreakfasts: "อาหารเช้าแบบโมร็อกโกแบบดั้งเดิม",
    highlightMeat: "ปลาสดและเนื้อสัตว์คุณภาพ",
    highlightJuices: "น้ำผลไม้ธรรมชาติและชาโมร็อกโก",
    highlightHealthy: "ประเพณีการทำอาหารเพื่อสุขภาพและอร่อย",
    galleryTitle: "แกลเลอรี่การทำอาหารของเรา",
    summaryP1: "เป้าหมายของเราคือการนำเสนอแขกของเราไม่เพียงแค่การเดินทางเท่านั้น แต่ยังเป็นการเดินทางด้านอาหารโมร็อกโกอย่างแท้จริงอีกด้วย",
    tagHealthy: "ดีต่อสุขภาพ",
    tagAuthentic: "ของแท้",
    tagTraditional: "แบบดั้งเดิม",
    tagFresh: "สด",
    tagUnique: "มีเอกลักษณ์",
    tagDelicious: "อร่อย",
    important: "สำคัญ:",
    guidanceNote: "เพื่อประสบการณ์การทำอาหารที่ดีที่สุด เราขอแนะนำอย่างยิ่งให้ปฏิบัติตามคำแนะนำของทีมงานของเราและคำแนะนำด้านการทำอาหารระหว่างการเดินทางของคุ���ในโมร็อกโก",
    whereMeal: "ที่ทุกมื้อกลายเป็นความทรงจำ",
    whatsappLabel: "วอทส์แอพ: +972 54-633-8757",
    moroccoLine: "สายโมร็อกโก: +212 6 63 63 05 79"
  },
  vip: {
    pageTitle: "วีไอพีและการเดินทางเพื่อธุรกิจ",
    pageSubtitle: "บริการพิเศษสำหรับซีอีโอ นักลงทุน และนักเดินทางผู้มีวิสัยทัศน์",
    introTitle: "ความเป็นเลิศที่ไร้รอยต่อในโมร็อกโก",
    introText: "MoroccoLovesYou มอบมาตรฐานการบริการที่เหนือชั้นสำหรับนักเดินทางเพื่อธุรกิจ คณะผู้แทนองค์กร และแขกวีไอพี เราเข้าใจดีว่าเวลาของคุณมีค่าและมาตรฐานของคุณก็ไม่ยอมแพ้ ตั้งแต่ลงจอดจนถึงออกเดินทาง เราจัดการทุกรายละเอียดด้วยความแม่นยำ ช่วยให้คุณมุ่งเน้นไปที่วัตถุประสงค์ทางธุรกิจของคุณ ในขณะที่เรามอบประสบการณ์โมร็อกโกที่ไร้ที่ติ",
    ctaTitle: "เข้าถึง CEO โดยตรง",
    ctaText: "หากต้องการสอบถามข้อมูลเร่งด่วนและคำขอเฉพาะทาง โปรดติดต่อ Ilan Hatchuel ผู้ก่อตั้งและซีอีโอของเราโดยตรง",
    ctaBtn: "ติดต่ออิลานตอนนี้",
    luxuryTransport: "การขนส่งที่หรูหรา",
    luxuryTransportDesc: "บริการรับส่งสนามบินแบบวีไอพีและคนขับรถส่วนตัวสองภาษาตลอด 24 ชั่วโมงทุกวันด้วยรถยนต์หรูหรา (Mercedes S-Class, V-Class)",
    premiumAccom: "ที่พักระดับพรีเมียม",
    premiumAccomDesc: "การจองสุดพิเศษที่โรงแรม 5 ดาว ริยาดหรู หรือวิลล่าส่วนตัวที่เหมาะสำหรับผู้บริหารและทีมงาน",
    businessConcierge: "เจ้าหน้าที่อำนวยความสะดวกทางธุรกิจ",
    businessConciergeDesc: "ความช่วยเหลือด้านการประชุมเต็มรูปแบบ การจองโต๊ะรับประทานอาหารแบบส่วนตัว และแผนการเดินทางเฉพาะสำหรับการพักผ่อนในองค์กร",
    securityPrivacy: "ความปลอดภัยและความเป็นส่วนตัว",
    securityPrivacyDesc: "บริการที่รอบคอบ สภาพแวดล้อมที่ปลอดภัย และการรักษาความลับอย่างสมบูรณ์สำหรับบุคคลและคนดังที่มีชื่อเสียง",
    support247: "การสนับสนุนตลอด 24 ชั่วโมงทุกวัน",
    support247Desc: "ติดต่อโดยตรงกับ CEO และทีมงานเฉพาะที่พร้อมช่วยเหลือคุณตลอดเวลาระหว่างการเข้าพัก",
    customItineraries: "แผนการเดินทางที่กำหนดเอง",
    customItinerariesDesc: "แผนการเดินทางที่ปรับให้เหมาะกับภาระผูกพันทางธุรกิจของคุณอย่างสมบูรณ์แบบด้วยประสบการณ์วัฒนธรรมโมร็อกโกระดับพรีเมียม"
  },
  worldcup: {
    pageTitle: "โมร็อกโก ฟุตบอลโลก 2030",
    pageSubtitle: "แพ็คเกจวีไอพีสุดพิเศษและประสบการณ์การเดินทางสำหรับงานฟุตบอลที่ยิ่งใหญ่ที่สุด",
    limitedBadge: "มีจำนวนจำกัด",
    introTitle: "สุดยอดการเดินทางฟุตบอล",
    introText: "ในป�� 2030 โมร็อกโกจะร่วมเป็นเจ้าภาพจัดการแข่งขันฟุตบอลโลก FIFA World Cup โดยนำการแข่งขันกีฬาอันทรงเกียรติที่สุดในโลกมาสู่แอฟริกาเหนือ MoroccoLovesYou มีความภูมิใจที่จะนำเสนอแพ็คเกจการเดินทางสุดหรูแบบรวมทุกอย่างสุดพิเศษที่ออกแบบมาสำหรับแฟนๆ ที่ต้องการความสะดวกสบาย การเข้าถึง และประสบการณ์ที่ดีที่สุด",
    packagesTitle: "แพ��คเกจฟุตบอลโลกระดับพรีเมียม",
    silverTitle: "แพ็คเกจซิลเวอร์",
    silverSub: "ประสบการณ์ที่สำคัญ",
    goldTitle: "แพ็คเกจโกลด์",
    goldSub: "ประสบการณ์อันหรูหรา",
    mostPopular: "ยอดนิยมที่สุด",
    diamondTitle: "ไดมอนด์ วีไอพี",
    diamondSub: "สุดยอดประสบการณ์",
    inquireWhatsApp: "สอบถามได้ทาง WhatsApp",
    ctaTitle: "รักษาสถานที่ของคุณก่อนที่ราคาจะสูงขึ้น",
    ctaText: "เนื่องจากมีความต้องการจากต่างประเทศสูงมาก เราขอแนะนำอย่างยิ่งให้จองแพ็คเกจ VIP ของคุณตั้งแต่เนิ่นๆ ที่พักในเมืองเจ้าภาพจะขายหมด",
    ctaBtn: "ติดต่อเราเลย",
    silverF1: "Riad พรีเมี่ยม / ที่พักโรงแรม 4 ดาว",
    silverF2: "โลจิสติกส์วันแข่งขันที่วางแผนไว้ล่วงหน้า",
    silverF3: "ทัวร์ชมเมืองพร้อมไกด์ (เมืองเจ้าภาพ)",
    silverF4: "สายสนับสนุนเฉพาะตลอด 24 ชั่วโมงทุกวัน",
    goldF1: "โรงแรม 5 ดาว / ที่พักวิลล่าหรู",
    goldF2: "บริการรับส่งสนามบินและการแข่งขันแบบส่วนตัว",
    goldF3: "ทริป VIP Desert Camp Getaway (2 วัน)",
    goldF4: "เจ้าหน้าที่อำนวยความสะดวกสองภาษาส่วนบุคคล",
    diamondF1: "ห้องเพรสซิเดนเชียล/พระราชวังส่วนตัว",
    diamondF2: "คนขับรถส่วนตัวและการรักษาความปลอดภัยตลอด 24 ชั่วโมงทุกวัน",
    diamondF3: "สิทธิพิเศษในการเข้าถึงกิจกรรมและปาร์ตี้วีไอพี",
    diamondF4: "การจัดการโดยตรงของ CEO และเจ้าหน้าที่ดูแลแขก VVIP"
  },
  gallery: {
    pageTitle: "แกลเลอรี่ของเรา",
    pageSubtitle: "ภาพความทรงจำของการเดินทางโมร็อกโกที่น่าจดจำ",
    picturesTitle: "โมร็อกโกในภาพ",
    picturesIntro: "สำรวจคอลเลกชันภาพถ่ายที่น่าทึ่งของเราจากโมร็อกโก",
    videosTitle: "โมร็อกโกในการเคลื่อนไหว",
    videosIntro: "สัมผัสประสบการณ์โมร็อกโกผ่านคอลเลกชันวิดีโอที่คัดสรรของเรา",
    catFood: "ประสบการณ์การทำอาหาร",
    catDestinations: "จุดหมายปลายทาง",
    catKosher: "โคเชอร์",
    catTransport: "ขนส่งวีไอพี"
  },
  testimonials: {
    pageTitle: "ข้อความรับรองแขก",
    pageSubtitle: "อ่านความคิดเห็นของนักเดินทางของเร���เกี่ยวกับประสบการณ์แบบโมร็อกโก",
    sectionTitle: "นักเดินทางที่มีความสุขของเรา",
    sectionIntro: "แขกที่พึงพอใจหลายพันคนได้สัมผัสกับความมหัศจรรย์ของโมร็อกโกกับเรา",
    verifiedGuest: "แขกที่ได้รับการยืนยัน",
    ratingsTitle: "การให้คะแนนของเรา",
    avgRating: "คะแนนเฉลี่ย",
    verifiedReviews: "บทวิจารณ์ที่ตรวจสอบแล้ว",
    fromReal: "จากนักเดินทางตัวจริง",
    custSatisfaction: "ความพึงพอใจของลูกค้า",
    wouldRecommend: "อยากจะแนะนำ",
    shareTitle: "แบ่งปันประสบการณ์ของคุณ",
    shareText: "มีทริปสุดพิเศษกับเราไหม? เราชอบที่จะได้ยินเกี่ยวกับเรื่องนี้!",
    shareBtn: "บอกเล่าเรื่องราวของคุณให้เราทราบ"
  },
  blog: {
    pageTitle: "บล็อกท่องเที่ยว",
    pageSubtitle: "เรื่องราว เคล็ดลับ และคำแนะนำสำหรับการผจญภัยในโมร็อกโกของคุณ",
    sectionTitle: "บทความท่องเที่ยวล่าสุด",
    sectionIntro: "อ่านบทความล่าสุดของเราเกี่ยวกับการเดินทางในโมร็อกโก วัฒนธรรมท้องถิ่น และเคล็ดลับภายใน",
    readMore: "อ่านเพิ่มเติม →",
    by: "โดย",
    newsletterTitle: "สมัครรับจ���หมายข่าวของเรา",
    newsletterText: "รับเคล็ดลับการเดินทางล่าสุดและข้อเสนอสุดพิเศษส่งตรงถึงกล่องจดหมายของคุณ",
    newsletterPlaceholder: "ใส่อีเมลของคุณ",
    subscribe: "สมัครสมาชิก"
  },
  contact: {
    pageTitle: "ติดต่อเราได้ทุกวันตลอด 24 ชั่วโมง",
    pageSubtitle: "ติดต่อกับทีมงานของเราเพื่อวางแผนการผจญภัยวีไอพีในโมร็อกโกของคุณ",
    getInTouch: "ติดต่อเรา",
    getInTouchText: "เราพร้อมให้ความช่วยเหลือและตอบทุกคำถามที่คุณอาจมี ทีมงานของเราพร้อมที่จะช่วยเหลือคุณในการวางแผนการเดินทางโมร็อกโกที่สมบูรณ์แบบของคุณ",
    address: "ที่อยู่ของเรา",
    addressText: "53 ถนน Mohammed V, Fes, โมร็อกโก",
    phone: "หมายเลขโทรศัพท์ 📞",
    directPhone: "โทรศัพท์สายตรง: +212 6 63 63 05 79",
    whatsappPhone: "วอทส์แอพ: +972 54 633 8757",
    email: "ที่อยู่อีเมลระดับมืออาชีพ",
    emailList: [
      "CEO@MoroccoLovesYou.com",
      "Info@MoroccoLovesYou.com",
      "Sales@MoroccoLovesYou.com",
      "Michael@MoroccoLovesYou.com",
      "Kim@MoroccoLovesYou.com"
    ],
    businessHours: "เวลาทำการ",
    businessHoursText: "พร้อมให้บริการทุกวันตลอด 24 ชั่วโมง\n7 วันต่อสัปดาห์",
    responseTime: "เราจะติดต่อกลับภายใน 48 ชั่วโมง",
    welcomeMessage: "ยินดีต้อนรับสู่โมร็อกโก 🇲🇲",
    followUs: "ติดตามเรา",
    formTitle: "ส่งข้อความถึงเรา",
    successMessage: "✓ ขอบคุณ! เราจะติดต่อกลับโดยเร็วที่สุด",
    firstName: "ชื่อ",
    lastName: "นามสกุล",
    emailAddress: "ที่อยู่อีเมล",
    phoneNumber: "หมายเลขโทรศัพท์",
    subject: "เรื่อง",
    selectSubject: "เลือกเรื่อง",
    tourInquiry: "สอบถามทัวร์",
    bookingQuestion: "คำถามเกี่ยวกับการจอง",
    customPackage: "แพ็คเกจแบบกำหนดเอง",
    feedback: "ข้อเสนอแนะ",
    other: "อื่นๆ",
    message: "รายละเอียด/ข้อความ",
    sendMessage: "ส่งข้อความ",
    mapTitle: "ค้นหาเราบนแผนที่",
    faqTitle: "คำถามที่พบบ่อย",
    faq1Q: "ไปเที่ยวโมร็อกโกช่วงไหนดี?",
    faq1A: "ฤดูใบไม้ผลิ (เมษายน-พฤษภาคม) และฤดูใบไม้ร่วง (กันยายน-ตุลาคม) เป็นช่วงที่มีอากาศดีที่สุด ฤดูร้อนอากาศจะร้อนในทะเลทราย ในขณะที่ฤดูหนาวอากาศอบอุ่นค่อนข้างเย็นแต่อาจมีฝนตกได้",
    faq2Q: "ฉันจำเป็นต้องมีวีซ่าเพื่อเยี่ยมชมโมร็อกโกหรือไม่?",
    faq2A: "ข้อกำหนดเกี่ยวกับวีซ่าขึ้นอยู่กับสัญชาติของคุณ หลายประเทศสามารถเข้าประเทศโดยไม่ต้องขอวีซ่าได้นานถึง 90 วัน ตรวจสอบกับสถานทูตในพื้นที่ของคุณ",
    faq3Q: "สกุลเงินใดที่ใช้ในโมร็อกโก?",
    faq3A: "Dirham โมร็อกโก (MAD) เป็นสกุลเงินอย่างเป็นทางการ ตู้เอทีเอ็มมีจำหน่ายทั่วไปในเมืองต่างๆ และสถานที่ส่วนใหญ่รับบัตรเครดิต",
    faq4Q: "พูดภาษาอะไรในโมร็อกโก?",
    faq4A: "ภาษาอาหรับและเบอร์เบอร์ (Amazigh) เป็นภาษาราชการ ภาษาฝรั่งเศสเป็นภาษาที่พูดกันอย่างแพร่หลาย และภาษาอังกฤษก็แพร่หลายมากขึ้นในพื้นที่ท่องเที่ยว",
    faq5Q: "ประเทศโมร็อกโกปลอดภัยสำหรับนักท่องเที่ยวหรือไม่?",
    faq5A: "ใช่ โดยทั่วไปโมร็อกโกจะปลอดภัยสำหรับนักท่องเที่ยว มีการใช้ข้อควรระวังสามัญสำนึก คำแนะนำของเรารับรองว่าคุณจะได้รับประสบการณ์ที่ปลอดภัยและสนุกสนาน",
    faq6Q: "ฉันสามารถปรับแต่งแพ็คเกจทัวร์ของฉันได้หรือไม่?",
    faq6A: "อย่างแน่นอน! เรานำเสนอแพ็คเกจแบบกำหนดเองที่ปรับให้เหมาะกับความสนใจ งบประมาณ และวันเดินทางของคุณ ติดต่อเราเพื่อหารือเกี่ยวกับความต้องการของคุณ"
  },
  about: {
    pageTitle: "เกี่ยวกับ MoroccoLovesYou",
    pageSubtitle: "คู่หูที่คุณไว้วางใจในการค้นพบความมหัศจรรย์ของโมร็อกโก",
    storyTitle: "เรื่องราวของเรา",
    storyP1: "MoroccoLovesYou ก่อตั้งขึ้นด้วยภารกิจง่ายๆ: เพื่อช่วยให้นักเดินทางได้สัมผัสกับความงาม วัฒนธรรม และการต้อนรับที่อบอุ่นอย่างแท้จริงของโมร็อกโก จุดเริ่มต้นจากบริการไกด์นำเที่ยวเล็กๆ ได้เติบโตขึ้นเป็นบริษัทการท่องเที่ยวแบบครบวงจรที่ให้บริก���รนักท่องเที่ยวนับพันคนต่อปี",
    storyP2: "ฟาติมา ฮัสซัน ผู้ก่อตั้งของเราตกหลุมรักโมร็อกโกและต้องการแบ่งปันความหลงใหลนี้กับโลก วันนี้ เราภาคภูมิใจในการสร้างสรรค์ประสบการณ์ที่เป็นส่วนตัวและแท้จริงที่นอกเหนือไปจากการท่องเที่ยวทั่วไป",
    missionTitle: "🎯 ภารกิจของเรา",
    missionText: "เพื่อมอบประสบการณ์การเดินทางสุดพิเศษที่แสดงถึงมรดกทางวัฒนธรรมอันยาวนานของโมร็อกโก ภูมิทัศน์ที่สวยงาม และการต้อนรับอันอบอุ่น ในขณะเดียวกันก็สนับสนุนชุมชนท้องถิ่นและแนวปฏิบัติด้านการท่องเที่ยวอย่างยั่งยืน",
    visionTitle: "🌟 วิสัยทัศน์ของเรา",
    visionText: "เป็นบริษัทท่องเที่ยวชั้นนำของโมร็อกโกที่เป็นที่รู้จักในด้านความถูกต้อง ความน่าเชื่อถือ และสร้างความทรงจำอันน่าจดจำสำหรับนักเดินทางทุกคนที่เลือกสำรวจประเทศอันงดงามนี้กับเรา",
    whyTitle: "ทำไมถึงเลือก MoroccoLovesYou?",
    expertTitle: "ความรู้จากผู้เชี่ยวชาญ",
    expertText: "ทีมงานของเรามีความรู้กว้างขวางเกี่ยวกับโมร็อกโกและให้คำแนะนำเฉพาะบุคคล",
    localTitle: "การเชื่อมต่อท้องถิ่น",
    localText: "เราทำงานร่วมกับมัคคุเทศก์ท้องถิ่นและครอบครัวเพื่อให้แน่ใจว่าจะได้รับประสบการณ์ที่แท้จริง",
    valueTitle: "คุ้มค่าที่สุด",
    valueText: "ราคาที่แข่งขันได้โดยไม่กระทบต่อคุณภาพและประสบการณ์",
    safetyTitle: "ความปลอดภัยและการสนับสนุน",
    safetyText: "รวมการสนับสนุนลูกค้าตลอด 24 ชั่วโมงทุกวันและประกันการเดินทางที่ครอบคลุม",
    sustainTitle: "การท่องเที่ยวอย่างยั่งยืน",
    sustainText: "เราสนับสนุนชุมชนท้องถิ่นและดำเนินการด้านการท่องเที่ยวอย่างรับผิดช��บ",
    bookingTitle: "จองง่าย",
    bookingText: "ขั้นตอนการจองออนไลน์ที่เรียบง่ายพร้อมตัวเลือกการชำระเงินที่ยืดหยุ่น",
    teamTitle: "ทีมงานของเรา",
    teamSubtitle: "พบกับผู้คนที่หลงใหลเบื้องหลัง MoroccoLovesYou",
    happyTravelers: "นักเดินทางที่มีความสุข",
    yearsExp: "ประสบการณ์หลายปี",
    destinationsCount: "จุดหมายปลายทาง",
    satisfactionRate: "อัตราความพึงพอใจ"
  },
  footer: {
    description: "ค้นพบความมหัศจรรย์ของโมร็อกโกไปกับเรา สัมผัสประสบการณ์การผจญภัยอันน่าจดจำและสร้างความทรงจำอันยาวนาน",
    quickLinks: "ลิงค์ด่วน",
    more: "เพิ่มเติม",
    contactInfo: "ข้อมูลการติดต่อ",
    copyright: "© 2024 MoroccoLovesYou. สงวนลิขสิทธิ์."
  },
  starBanner: {
    ceoMessage: "สารจากซีอีโอ",
    watchVideo: "ดูวิดีโอของฉัน",
    readMessage: "& อ่านข้อความของฉัน",
    getToKnow: "ทำความรู้จัก",
    ilanPersonally: "โดยส่วนตัวแล้วอิลัน"
  },
  cityDetail: {
    notFound: "ไม่พบเมือง",
    backHome: "กลับไปที่บ้าน",
    discoverSubtitle: "ค้นพบความงามและวัฒนธรรม",
    planTrip: "วางแผนการเดินทางของฉันไป",
    galleryOf: "แกลลอรี่ของ",
    bookExperience: "จองประสบการณ์นี้",
    requestItinerary: "ขอรายละเอียดการเดินทางแบบเต็ม",
    readyToVisit: "พร้อมเยี่ยมชม",
    readyToVisitText: "ให้เราวางแผนการเดินทางที่สมบูรณ์แบบของคุณไปยังจุดหมายปลายทางที่��่าตื่นตาตื่นใจนี้",
    planMyTrip: "วางแผนการเดินทางของฉัน",
    talkExpert: "พูดคุยกับผู้เชี่ยวชาญ"
  },
  transportation: {
    pageTitle: "การขนส่งและคนขับรถวีไอพี",
    pageSubtitle: "ความหรูหรา ความสะดวกสบาย และปลอดภัยทั่วโมร็อกโก",
    introTitle: "การขนส่งและคนขับรถวีไอพีของเรา",
    introP1: "ที่ Morocco Loves You การคมนาคมไม่ได้เป็นเพียงการเคลื่อนย้ายจากที่หนึ่งไปอีกที่หนึ่งเท่านั้น",
    introP2: "มันเป็นส่วนหนึ่งของประสบการณ์",
    introP3: "เราจัดหายานพาหนะปรับอากาศที่ทันสมัย ​​สะอาด สะดวกสบาย และมีเครื่องปรับอากาศทั่วโมร็อกโก พร้อมด้วยคนขับมืออาชีพ การต้อนรับที่อบอุ่น และบริการระดับวีไอพีตั้งแต่วินาทีแรก",
    introP4: "ไม่ว่าคุณจะเดินทางเป็นคู่รัก ครอบครัว คณะธุรกิจ หรือกลุ่มส่วนตัว เรามั่นใจว่าการเดินทางของคุณปลอดภัย ผ่อนคลาย และน่าจดจำ",
    servicesTitle: "บริการขนส่งของเราประกอบด้วย",
    servicesList: [
      "รถบัสวีไอพีที่ทันสมัย",
      "รถมินิบัสสุดหรู",
      "รถยนต์ส่วนตัว",
      "รถจี๊ป 4x4 สำหรับการผจญภัยในทะเลทราย",
      "รถลีมูซีนวีไอพี",
      "รับและส่งสนามบิน",
      "ไดรเวอร์หลายภาษาระดับมืออาชีพ",
      "เครื่องปรับอากาศที่สะดวกสบาย",
      "ยานพาหนะที่สะอาดและเป็นระเบียบ",
      "ตู้เย็นในยานพาหนะที่เลือก",
      "ทีวีและระบบความบันเทิง",
      "ดนตรีระหว่างการเดินทาง",
      "การขับขี่ที่ปลอดภัยและราบรื่น",
      "ความช่วยเหลือตลอด 24 ชั่วโมงทุกวันทั่วโมร็อกโก"
    ],
    featureList: [
      "รถบัสวีไอพีที่ทันสมัย",
      "รถมินิบัสสุดหรู",
      "รถยนต์ส่วนตัว",
      "รถจี๊ป 4x4",
      "รับที่สนามบิน",
      "ไดรเวอร์หลายภาษา",
      "ความช่วยเหลือตลอด 24 ชั่วโมงทุกวัน",
      "การขับขี่อย่างปลอดภัย"
    ],
    driversTitle: "พบกับคนขับรถของเรา",
    driversText1: "คนขับรถของเราเป็นส่วนหนึ่งของครอบครัว Morocco Loves You",
    driversText2: "เป็นมืออาชีพ ให้ความเคารพ มีประสบการณ์ และพร้อมให้ความช่วยเหลือด้วยรอยยิ้มเสมอ",
    driversText3: "พนักงานขับรถของเราหลายคนพูดได้หลายภาษาและรู้จักโมร็อกโกอย่างลึกซึ้ง ช่วยให้แขกของเรารู้สึกสะดวกสบาย ปลอดภัย และเชื่อมโยงกันตลอดการเดินทาง",
    safetyTitle: "ความปลอดภัยและความสบายต้องมาก่อน",
    safetyText1: "ความสะดวกสบายและความปลอดภัยของคุณคือสิ่งสำคัญที่สุดของเรา",
    safetyText2: "ยานพาหนะทุกคันได้รับการบำรุงรักษา ทำความสะอาด และเตรียมพร้อมอย่างรอบคอบก่อนการเดินทางทุกครั้ง",
    safetyText3: "เราทำงานร่วมกับคนขับรถมืออาชีพที่เชื่อถือได้และพันธมิตรด้านการขนส่งคุณภาพสูงเท่านั้น",
    categories: {
      buses: "รถบัสวีไอพี",
      minibuses: "รถมินิบัสสุดหรู",
      cars: "รถยนต์ส่วนตัวและรถรับส่งวีไอพี",
      jeeps: "รถจี๊ป 4x4 และการขนส่งในทะเลทราย",
      meetDrivers: "พบกับคนขับรถของเรา",
      videos: "วิดีโอประสบการณ์การขนส่ง"
    },
    videoGalleryTitle: "วิดีโอประสบการณ์วีไอพี",
    ctaTitle: "พร้อมที่จะสำรวจโมร็อกโกอย่างสะดวกสบายแล้วหรือยัง?",
    ctaSubtitle: "พูดโดยตรงกับ Allan – CEO และผู้ก่อตั้ง",
    whatsapp: "วอทส์แอพ: +972546338757",
    moroccoLine: "สายตรงโมร็อกโก: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "ทัวร์โคเชอร์สุดหรูในโมร็อกโก",
    pageSubtitle: "มรดกชาวยิวแท้ อาหารโคเชอร์ 100% การต้อนรับอันหรูหรา และประสบการณ์โมร็อกโกอันเป็นเอกลักษณ์",
    introTitle: "ประสบการณ์มรดกชาวยิวอันหรูหรา",
    introHeading: "ค้นพบโมร็อกโกของชาวยิวที่แท้จริง",
    introText: "ค้นพบรากฐานอันลึกซึ้งของประวัติศาสตร์ชาวยิวในโมร็อกโกด้วยประสบการณ์การเดินทางที่หรูหรา แท้จริง และระดับพรีเมียม เราเชี่ยวชาญในการมอบการเดินทางที่ราบรื่นสำหรับชุมชนชาวยิวทั่วโลก โดยมุ่งเน้นไปที่มรดก การเชื่อมโยง และความสะดวกสบายอย่างแท้จริง",
    introQuote: "\"โมร็อกโกเป็นดินแดนแห่งความอดทนและการอยู่ร่วมกัน ที่ซึ่งมรดกของชาวยิวได้รับการอนุรักษ์ไว้ด้วยความรักและความเคารพ\"",
    experiencesTitle: "ประสบการณ์โคเชอร์ของเราประกอบด้วย",
    experiencesList: [
      "อาหารและร้านอาหารโคเชอร์ 100%",
      "มีเชฟโคเชอร์ส่วนตัว",
      "อาหารยิวโมร็อกโกแบบดั้งเดิม",
      "โรงแรมหรูระดับ 4 และ 5 ดาว",
      "การขนส่งวีไอพีส่วนตัว",
      "ไกด์มืออาชีพหลายภาษา",
      "ทัวร์มรดกชาวยิวและสุเหร่ายิว",
      "สุสานและพิพิธภัณฑ์ชาวยิว",
      "ประสบการณ์ทะเลทรายซาฮาราและฮัมมัม",
      "ความช่วยเหลืออย่างมืออาชีพตลอด 24 ชั่วโมงทุกวัน"
    ],
    expFood: "อาหารโคเชอร์ 100%",
    expRestaurant: "ร้านอาหารโคเชอร์",
    expChef: "มีเชฟโคเชอร์ส่วนตัว",
    expCuisine: "อาหารยิวโมร็อกโกแบบดั้งเดิม",
    expHotels: "โรงแรมหรู 4 และ 5 ดาว",
    expDeluxeHotels: "โรงแรมดีลักซ์ตามคำขอ",
    expTransport: "การขนส่งวีไอพีส่วนตัว",
    expDrivers: "นักขับมืออาชีพ",
    expAC: "รถปรับอากาศ",
    expWifi: "WiFi ทีวี และตู้เย็นในยานพาหนะที่เลือก",
    expGuides: "ไกด์มืออาชีพหลายภาษา",
    expStaff: "พนักงานที่พูดภาษาฮิบรู / อังกฤษ / ฝรั่งเศส / สเปน / รัสเซีย / เยอรมัน",
    expHeritage: "ทัวร์มรดกชาวยิว",
    expSynagogues: "สุเหร่าโบราณ",
    expCemeteries: "สุสานชาวยิว",
    expMuseums: "พิพิธภัณฑ์ชาวยิว",
    expSpiritual: "ประสบการณ์ทางจิตวิญญาณและวัฒนธรรม",
    expDesert: "ประสบการณ์ทะเลทรายซาฮารา",
    expHammam: "ประสบการณ์ฮัมมัมแบบโมร็อกโก",
    expAttractions: "สถานที่ท่องเที่ยวอันเป็นเอกลักษณ์ทั่วโมร็อกโก",
    expAssistance: "ช่วยเหลือตลอด 24 ชั่วโมงทุกวัน",
    packagesTitle: "แพ็คเกจท่องเที่ยวโคเชอร์ที่ยืดหยุ่น",
    packagesIntro: "เราปรับแต่งการเดินทางทุกครั้งตามความต้องการ ปร���เพณี สไตล์การเดินทาง วันที่ และความคาดหวังของแขกของเรา",
    packageOptions: [
      "4-5 วัน",
      "7–8 วัน",
      "10–11 วัน",
      "13–14 วัน",
      "21 วัน",
      "ทัวร์ส่วนตัวที่ออกแบบตามความต้องการ"
    ],
    package4_5: "4-5 วัน",
    package7_8: "7–8 วัน",
    package10_11: "10–11 วัน",
    package13_14: "13–14 วัน",
    package21: "21 วัน",
    packageTailor: "ทัวร์ส่วนตั���ที่ออกแบบตามความต้องการ",
    packagesQuote: "“เราปรับแต่งทุกการเดินทางตามความต้องการ ประเพณี สไตล์การเดินทาง วันที่ และความคาดหวังของแขกของเรา”",
    safetyTitle: "การเดินทางที่สะดวกสบาย เป็นมืออาชีพ และปลอดภัย",
    safetyText: "ทัวร์ของเราดำเนินการโดยให้ความสำคัญกับความสะดวกสบาย การจัดองค์กร คุณภาพการบริการ และการประสานงานอย่างมืออาชีพทั่วโมร็อกโก",
    safetyQuote: "“ทัวร์ของเราดำเนินการโดยคำนึงถึงความสะดวกสบาย การจัดองค์กร คุณภาพการบริการ และการประสานงานอย่างมืออาชีพทั่วโมร็อกโก”",
    b2bTitle: "ความร่วมมือด้านการท่องเที่ยวของชาวยิว B2B",
    b2bText: "เราร่วมมือกับชุมชนชาวยิว สุเหร่ายิว แรบไบ และบริษัททัวร์โคเชอร์ทั่วโลก เพื่อสร้างการเดินทางมรดกที่มีความหมาย",
    b2bPartnersList: "เราทำงานร่วมกับ: ชุม���นชาวยิว สุเหร่ายิว แรบไบ องค์กรชาวยิว บริษัททัวร์โคเชอร์ และตัวแทนการท่องเที่ยวทั่วโลก",
    partnerBtn: "มาเป็นพันธมิตรกับเรา",
    galleryTitle: "แกลเลอรีประสบการณ์โคเชอร์",
    videosTitle: "วิดีโอเด่น",
    ctaTitle: "พร้อมที่จะเริ่มต้นการเดินทางของคุณแล้วหรือยัง?",
    msgAllan: "ส่งข้อความถึงอัลลันทาง WhatsApp",
    callMorocco: "โทรโมร็อกโก: +212 6 63 63 05 79",
    ceoContact: "พูดคุยกับ Allan Hatchuel โดยตรงบน WhatsApp",
    exploreBtn: "สำรวจทัวร์โคเชอร์"
  },
  aria: {
    selectLanguage: "เลือกภาษา",
    closeDetails: "ปิดรายละเอียด",
    openMenu: "เปิดเมนู",
    closeMenu: "ปิดเมนู",
    kosherTravel: "โคเชอร์ท่องเที่ยวโมร็อกโก",
    watchVideo: "ชมวิดีโอ Magic Morocco",
    followInstagram: "ติดตามเราบนอินสตาแกรม",
    followFacebook: "ติดตามเราบน Facebook",
    ceoMessage: "ซีอีโอแห่งโมร็อกโกรักคุณ",
    whatsappSocial: "วอทส์แอพพ์",
    instagramSocial: "อินสตาแกรม",
    facebookSocial: "เฟสบุ๊ค",
    logoAlt: "โลโก้โมร็อกโก LovesYou",
    kingAlt: "กษัตริย์แห่งโมร็อกโก",
    kosherOptionsAlt: "ตัวเลือกโคเชอร์",
    moroccoLandscape: "ภูมิทัศน์ของโมร็อกโก",
    worldCupAlt: "ถ้วยรางวัลฟุตบอลโลกพร้อมธงโมรอคโค",
    b2bBannerAlt: "แบน��นอร์ทัวร์ B2B เท่านั้น - คลิกเพื่อ WhatsApp",
    starAlt: "ดาว",
    playVideo: "เล่น",
    pauseVideo: "หยุดชั่วคราว",
    vipBus: "รถบัสวี���อพี",
    drivers: "ไดรเวอร์ของเรา",
    jewishHeritageArchitecture: "สถาปัตยกรรมมรดกของชาวยิว",
    jewishHeritageMorocco: "มรดกของชาวยิวโมร็อกโก",
    kosherFoodMorocco: "อาหารโคเชอร์ โมร็อกโก",
    jewishHeritageExperience: "ประสบการณ์มรดกของชาวยิว",
    kosherMoroccanTable: "โต๊ะโคเชอร์โมร็อกโก",
    luxuryHospitality: "การต้อนรับที่หรูหรา",
    kosherExperience: "ประสบการณ์โคเชอร์"
  },
  forms: {
    firstName: "เช่น จอห์น",
    lastName: "เช่น โด้",
    email: "name@example.com",
    subject: "เราสามารถช่วยได้อย่างไร?",
    message: "บอกเราเพิ่มเติมเกี่ยวกับแผนการเดินทางของคุณ...",
    phone: "หมายเลขโทรศัพท์ของคุณ",
    date: "เลือกวันที่",
    guests: "จำนวนแขก"
  },
  common: {
    selectLanguage: "เลือกภาษา",
    instagram: "อินสตาแกรม",
    facebook: "เฟสบุ๊ค",
    loading: "กำลังโหลด...",
    error: "เกิดข้อผิดพลาด",
    success: "สำเร็จ!",
    noResults: "ไม่พบผลลัพธ์",
    viewMore: "ดูเพิ่มเติม",
    viewLess: "ดูน้อยลง",
    bookNow: "จองตอนนี้",
    learnMore: "เรียนรู้เพิ่มเติม",
    contactUs: "ติดต่อเรา",
    close: "ปิด",
    back: "กลับ",
    next: "ถัดไป",
    previous: "ก่อนหน้า",
    search: "ค้นหา...",
    filter: "ตัวกรอง",
    sort: "จัดเรียง",
    price: "ราคา",
    duration: "ระยะเวลา",
    languages: {
      english: "อังกฤษ",
      american: "อเมริกัน",
      australia: "ออสเตรเลีย",
      canada: "แคนาดา",
      french: "ฝรั่งเศส",
      spanish: "สเปน",
      hebrew: "ภาษาฮีบรู",
      arabic: "العربية",
      german: "เยอรมัน",
      italian: "ภาษาอิตาลี",
      japanese: "ภาษาญี่ปุ่น",
      chinese: "จีน",
      korean: "เกาหลี",
      vietnamese: "ภาษาเวียดนาม",
      russian: "ภาษารัสเซีย",
      en: "อังกฤษ",
      "en-US": "อเมริกัน",
      "en-AU": "ออสเตรเลีย",
      "en-CA": "แคนาดา",
      fr: "ฝรั่งเศส",
      es: "สเปน",
      he: "ภาษาฮีบรู",
      ar: "العربية",
      de: "เยอรมัน",
      it: "ภาษาอิตาลี",
      ja: "ภาษาญี่ปุ่น",
      zh: "จีน",
      ko: "เกาหลี",
      vi: "ภาษาเวียดนาม",
      ru: "ภาษารัสเซีย",
      th: "ไทย"
    }
  },
  whatsapp: {
    greeting: "สวัสดีโมร็อกโกรักคุณ! 🌟",
    bookPackage: "ฉันต้องการจองแพ็คเกจดังต่อไปนี้:",
    packageInfo: "📦 แพ็คเกจ: ",
    duration: "⏱️ระยะเวลา: ",
    price: "💰 ราคา: ",
    bookingRequest: "โปรดแจ้งให้เราทราบความพร้อมและขั้นตอนต่อไป ขอบคุณ!",
    cityTrip: "ฉันต้องการวางแผนการเดินทางไป {city} คุณช่วยฉันได้ไหม?",
    silverPackage: "ฉันสนใจแพ็คเกจ Silver World Cup",
    goldPackage: "สนใจแพ็คเกจโกลด์เวิลด์คัพครับ",
    diamondPackage: "ฉันสนใจแพ็คเกจ VIP Diamond World Cup",
    worldCupSecure: "สวัสดี ฉันต้องการจองที่นั่งสำหรับโมร็อกโกปี 2030",
    kosherInquiry: "ฉันสนใจแพ็คเกจท่องเที่ยวโคเชอร์โมร็อ��โกของคุณ",
    customPackage: "ฉันต้องการสร้างแพ็คเกจแบบกำหนดเองสำหรับกลุ่มของเรา",
    businessInquiry: "ฉันสนใจบริการการเดินทางเพื่อธุรกิจวีไอพี"
  },
  blog_posts: {
    post1: {
      title: "10 อัญมณีที่ซ่อนอยู่ให้ค้นพบในโมร็อกโก",
      author: "ฟาติมา ฮัสซัน",
      date: "15 มีนาคม 2024",
      category: "คู่มือการเดินทาง",
      excerpt: "ค้นพบจุดหมา��ปลายทางที่ไม่ค่อยมีคนรู้จักและขุมทรัพย์ที่ซ่อนอยู่ของโมร็อกโกที่นักท่องเที่ยวส่วนใหญ่พลาด สำรวจโมร็อกโกแท้ๆ ตั้งแต่หมู่บ้านบนภูเขาอันลึกลับไปจนถึงพื้นที่ชายฝั่งทะเลอันบริสุทธิ์",
      content: "โมร็อกโกเป็นมากกว่าแค่มาร์ราเกชและคาซาบลังกา คู่มือฉบับสมบูรณ์นี้จะเผยอัญมณีที่ซ��อนอยู่..."
    },
    post2: {
      title: "เวลาที่ดีที่สุดในการเยี่ยมชมโมร็อกโก: คู่มือฉบับสมบูรณ์",
      author: "อาเหม็ด เบนนานี",
      date: "10 มีนาคม 2024",
      category: "การวางแผน",
      excerpt: "กำลังวางแผนการเดินทางโมร็อกโกอยู่ใช่ไหม? เรียนรู้เกี่ยวกับฤดูกาลที่ดีที่สุดในการเยี่ยมชม สิ่งที่คาดหวังจากสภาพอากาศ และวิธีใช้การเดินทางให้เกิดประโยชน์สูงสุดตลอดทั้งปี",
      content: "การเลือกเวลาที่เหมาะสมในการไปเยือนโมร็อกโกอาจส่งผลต่อประสบการณ์การเดินทางของคุณได้อย่างมาก นี่คือคำแนะนำฉบับสมบูรณ์ของเรา..."
    },
    post3: {
      title: "อาหารโมร็อกโก: การผจญภัยด้านการทำอาหาร",
      author: "ไลลา ราฮิม",
      date: "5 มีนาคม 2567",
      category: "อาหารและวัฒนธรรม",
      excerpt: "เริ่มต้นการเดินทางทำอาหารผ่านโมร็อกโก ค้นพบรสชาติที่หลากหลาย สูตรอาหารแบบดั้งเดิม และประสบการณ์การรับประทานอาหารที่ทำให้���าหารโมร็อกโกมีชื่อเสียงไปทั่วโลก",
      content: "อาหารโมร็อกโกเป็นการผสมผสานระหว่างอิทธิพลของอาหรับ เบอร์เบอร์ อันดาลูเซีย และแอฟริกา อาหารแต่ละจานบอกเล่าเรื่องราวมรดกอันหลากหลายของโมร็อกโก..."
    },
    post4: {
      title: "วิธีต่อราคาในตลาดโมร็อกโกอย่างมืออาชีพ",
      author: "ยูสเซฟ อลาอุย",
      date: "28 กุมภาพันธ์ 2024",
      category: "เคล็ดลับการเดินทาง",
      excerpt: "ฝึกฝนศิลปะการต่อราคาในตลาดและตลาดโมร็อกโก เรียนรู้มารยาททางวัฒนธรรม กลยุทธ์การเจรจา และเคล็ดลับจากวงในเพื่อรับข้อเสนอที่ดีที่สุด",
      content: "การทะเลาะวิวาทไม่ได้เป็นเพียงธุรกรรมในตลาดโมร็อกโกเท่านั้น มันเป็นการแลกเปลี่ยนทางวัฒนธรรม ต่อไปนี้เป็นวิธีดำเนินการด้วยความเคารพและมีประสิทธิภาพ..."
    },
    post5: {
      title: "เดินป่าเทือกเขาแอตลาส: สิ่งที่คุณต้องรู้",
      author: "อาเหม็ด เบนนานี",
      date: "20 กุมภาพันธ์ 2024",
      category: "การผจญภัย",
      excerpt: "สำรวจเทือกเขาแอตลาสอันยิ่งใหญ่ด้วยการเดินเท้า รับคำแนะนำจากผู้เชี่ยวชาญเกี่ยวกับเส้นทางเดินป่า สิ่งที่ต้องจัดกระเป๋า การพิจารณาระดับความสูง และเวลาที่ดีที่สุดสำหรับการผจญภัยบนภูเขาของคุณ",
      content: "เทือกเขาแอตลาสมีภูมิประเทศที่น่าทึ่งที่สุดในแอฟริกาเหนือ ไม่ว่าคุณจะเป็นนักเดินป่าผู้ช่ำชองหรือมือใหม่..."
    },
    post6: {
      title: "Desert Safari: ประสบการณ์อันน่าจดจำ",
      author: "ฟาติมา ฮัสซัน",
      date: "15 กุมภาพันธ์ 2567",
      category: "การผจญภัย",
      excerpt: "สัมผัสความมหัศจรรย์ของทะเลทรายซาฮาราแห่งโมร็อกโก การขี่อูฐ ค่ำคืนที่เต็มไปด้วยดวงดาวใต้เต็นท์ผ้าใบ และช่วงเวลาพระอาทิตย์ขึ้นที่คุณจะไม่มีวันลืม",
      content: "ทะเลทรายซาฮาราเป็นตัวแทนของจิตวิญญาณของโมร็อกโก ซาฟารีในทะเลทรายเป็นมากกว่าการผจญภัย มันคือการเดินทางทางจิตวิญญาณ..."
    },
    post7: {
      title: "มารยาททางวัฒนธรรม: เคารพประเพณีโมร็อกโก",
      author: "ไลลา ราฮิม",
      date: "10 กุมภาพันธ์ 2024",
      category: "วัฒนธรรม",
      excerpt: "เรียนรู้บรรทัดฐานทางวัฒนธรรม ประเพณี และมารยาทที่จำเป็นในการมีส่วนร่วมกับผู้คนและประเพณีโมร็อกโกด้วยความเคารพระหว่างการเยี่ยมชมของคุณ",
      content: "การทำความเข้าใจและเคารพประเพณีท้องถิ่นเป็นสิ่งสำคัญเมื่อเดินทางไปโมร็อกโก คู่มือนี้ครอบคลุมถึงหลักปฏิบัติทางวัฒนธรรมที่สำคัญ..."
    },
    post8: {
      title: "การถ่ายภาพในโมร็อกโก: จับภาพความมหัศจรรย์",
      author: "ยูสเซฟ อลาอุย",
      date: "5 กุมภาพันธ�� 2567",
      category: "การถ่ายภาพ",
      excerpt: "ค้นพบสถานที่ถ่ายรูปสวยที่สุดในโมร็อกโก และเคล็ดลับระดับมืออาชีพในการถ่ายภาพทิวทัศน์ ผู้คน และวัฒนธรรมอันน่าทึ่ง",
      content: "โมร็อกโกเป็นสวรรค์ของช่างภาพ ตั้งแต่เมดินาสีน้ำเงินไปจนถึงทะเลทรายสีทอง ทุกมุมมอบโอกาสในการถ่ายรูปอันน่าทึ่ง..."
    }
  },
  jobs: {
    title: "อาชีพและโอกาส",
    intro: "เข้าร่วมทีม MoroccoLovesYou และสร้างอนาคตของคุณด้วยการเดินทางที่หรูหรา",
    workWith: "ทำงานด้วยความรัก ความเอาใจใส่ และความเป็นเลิศ",
    introText: "เรากำลังมองหาบุคคลที่มีความกระตือรือร้นและทุ่มเทซึ่งมีวิสัยทัศน์ในการมอบประสบการณ์การเดินทางระดับโลกเช่นเดียวกับเรา เข้าร่วมทีมที่กำลังเติบโตของเราและเป็นส่วนหนึ่งของสิ่งที���พิเศษ",
    openPositions: "เปิดตำแหน่ง",
    requirements: "ข้อกำหนด:",
    readyJoin: "พร้อมที่จะเข้าร่วมกับเราแล้วหรือยัง?",
    sendCV: "ส่ง CV ของคุณมาที่ careers@moroccolovesyou.com",
    instructions: "รวมจดหมายปะหน้าสั้นๆ ที่อธิบายว่าทำไมคุณถึงอยากเข้าร่วมทีม Morocco Loves You",
    emailCv: "ส่งอีเมล CV ถึง CEO",
    chatCeo: "พูดคุยกับ CEO บน WhatsApp",
    job1: {
      title: "ไกด์นำเที่ยวมืออาชีพหลายภาษา",
      type: "เต็มเวลา / ตามฤดูกาล",
      location: "Marrakech / Fes / ทั่วทั้งโมร็อกโก",
      description: "เรากำลังมองหาไกด์ที่หลงใหล มีความรู้ และเล่าเรื่องซึ่งสามารถทำให้โมร็อกโกมีชีวิตชีวาสำหรับแขกวีไอพีของเรา บทบาทของคุณเกี่ยวข้องกับการนำทัวร์ระดับพรีเมียม แบ่งปันข้อมูลเชิงลึกทางวัฒนธรรม และรับประกันความพึงพอใจของแขก",
      req1: "พูดได้อย่างน้อย 2 ภาษา (แนะนำให้ใช้ภาษาฝรั่งเศส สเปน อังกฤษ ฮิบรู เยอรมัน รัสเซีย ห���ืออิตาลี)",
      req2: "ความรู้เชิงลึกเกี่ยวกับประวัติศาสตร์ วัฒนธรรม และภูมิศาสตร์ของโมร็อกโก",
      req3: "มีมนุษยสัมพันธ์ดี มีทักษะการบริการลูกค้าที่เป็นเลิศ",
      req4: "สมรรถภาพทางกายสำหรับการเดินป่าในทะเลทรายและกิจกรรมกลางแจ้ง"
    },
    job2: {
      title: "พนักงานขับรถผู้บริหารวีไอพี",
      type: "เต็มเวลา",
      location: "ทั่วทั้งโมร็อกโก",
      description: "เข้าร่วมทีมขนส่งสุดหรูของเราที่ขับรถ Mercedes ระดับไฮเอนด์ที่ทันสมัย คุณจะให้บริการรับส่งแบบวีไอพี รับประกันความสะดวกสบายและปลอดภัยของแขก และเป็นตัวแทนของแบรนด์ของเราด้วยความเป็นมืออาชีพและการต้อนรับ",
      req1: "มีใบขับขี่ที่ถูกต้องแ��ะมีประวัติการขับขี่ที่ดีเยี่ยม (มีประสบการณ์มากกว่า 10 ปีจะพิจารณาเป็นพิเศษ)",
      req2: "ความคล่องแคล่วในภาษาอังกฤษ (ภาษาเพิ่มเติมจะได้รับการพิจารณาเป็นพิเศษ)",
      req3: "รูปลักษณ์ที่เป็นมืออาชีพและกิริยาท่าทางที่สุภาพ",
      req4: "ความรู้เกี่ยวกับถนนและเส้นทางของโมร็อกโก ประสบการณ์ GPS / การนำทาง"
    },
    job3: {
      title: "ผู้ประสานงานประสบการณ์ลูกค้า",
      type: "เต็มเวลา",
      location: "รีโมท / ไฮบริด (สำนักงาน Fes)",
      description: "สนับสนุนสำนักงาน CEO ของเราในการจัดแผนการเดินทางที่หรูหราแบบกำหนดเอง จัดการการสื่อสารกับแขก และรับประกันการประสานงานการเดินทางที่ราบรื่น บทบาทนี้เหมาะสำหรับมืออาชีพที่เน้นการจัดระเบียบและใส่ใจรายละเอียด",
      req1: "ทักษะการจัดองค์กรและการสื่อสารที่ยอดเยี่ยม",
      req2: "มีประสบการณ์ด้านการท่องเที่ยว การต้อนรับ หรือการบริการลูกค้า",
      req3: "พูดภาษาอังกฤษได้คล่อง ภาษาเพิ่มเติม��ป็นโบนัส",
      req4: "มีทักษะด้านระบบการจองและ Microsoft Office Suite"
    }
  },
  gallery_categories: {
    food: "ประสบการณ์การทำอาหาร",
    destinations: "จุดหมายปลายทาง",
    kosher: "โคเชอร์",
    transport: "ขนส่งวีไอพี"
  }
};

export default th;
